var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FF241DD4-ABE3-4317-8CB9-01416FFB4BA9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marketing-support->-Logos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MOBILE-logos-default",
    transform: "translate(-280.000000, -409.000000)",
    fill: "#006F44",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table/mobile/default1",
    transform: "translate(20.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_touch-down_2684470",
    transform: "translate(260.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2928932,10.2928932 C15.6834175,9.9023689 16.3165825,9.9023689 16.7071068,10.2928932 C17.0976311,10.6834175 17.0976311,11.3165825 16.7071068,11.7071068 L11.7071068,16.7071068 C11.3165825,17.0976311 10.6834175,17.0976311 10.2928932,16.7071068 L5.2928932,11.7071068 C4.9023689,11.3165825 4.9023689,10.6834175 5.2928932,10.2928932 C5.6834175,9.9023689 6.3165825,9.9023689 6.7071068,10.2928932 L9.99999997,13.5857864 L9.99999997,1 C9.99999997,0.4477153 10.4477153,0 11,0 C11.5522847,0 12,0.4477153 12,1 L12,13.5857864 L15.2928932,10.2928932 Z M1,23 C0.4477153,23 0,22.5522847 0,22 C0,21.4477153 0.4477153,21 1,21 L21,21 C21.5522847,21 22,21.4477153 22,22 C22,22.5522847 21.5522847,23 21,23 L1,23 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/download_2.a65313efd494014641c9051be48b61ad.svg";
export { ForwardRef as ReactComponent };